module.exports = __webpack_public_path__ + "img/uploadid.c1b8819b.svg";